'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import { useMemo } from 'react'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { useWidgetSectionPosition } from '@src/components/pl-base-widget/contexts/widget-page-order'
import { usePLPageMetaOptional } from '@src/components/pl-page-context'
import ProductShowcaseWithDSGate from '@src/SectionRenderer/sections/productShowcase'

import { PLSectionTrackingWrapper } from '../pl-section-tracking-wrapper'

import { buildProductShowcaseConfig } from './product-showcase-section-builders'

import type { ProductShowcaseWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

function hasShowcaseContent(data: ProductShowcaseWidgetData): boolean {
  return Boolean(data.richTexts.length || data.images.length || data.genericContents.length)
}

const ProductShowcaseWidgetComponent = (props: PLTypedWidgetProps<ProductShowcaseWidgetData>) => {
  const data = props.data.productShowcaseData
  const tracker = usePLPageMetaOptional()?.sectionTracker
  const sectionPosition = useWidgetSectionPosition(props.id)

  const sectionConfig = useMemo(
    () => (data && hasShowcaseContent(data) ? buildProductShowcaseConfig(data, tracker, sectionPosition) : null),
    [data, tracker, sectionPosition],
  )
  if (!sectionConfig) return null

  return (
    <PLSectionTrackingWrapper sectionConfig={sectionConfig} tracker={tracker}>
      <ProductShowcaseWithDSGate sectionConfig={sectionConfig} />
    </PLSectionTrackingWrapper>
  )
}

export const ProductShowcaseWidget: PLTypedWidgetInterface<ProductShowcaseWidgetData, WidgetType.PRODUCT_SHOWCASE> = {
  id: WidgetType.PRODUCT_SHOWCASE,
  errorBoundary: PLBaseErrorBoundary,
  render: ProductShowcaseWidgetComponent,
}
